module.exports = __webpack_public_path__ + "static/media/garanties_assistance.b18a3865.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/adhesion/garanties_assistance.pdf
// module id = 845
// module chunks = 40